var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.sendBasicInformation)?_c('NewProjectBasicInformation',{on:{"completed":_vm.handleCompleted}}):_c('NewProjectChargeData',{attrs:{"projectData":_vm.projectData},on:{"completedProject":_vm.changeComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }